export default {
  data() {
    return {
      selected: true,
      options: [
        { text: '購物問題', value: true },
        { text: '建議回饋', value: false },
      ],
    };
  },
  mounted() {},
};
